import moment from 'moment';

export const isToday = (date: Date): boolean => {
  return moment().diff(date, 'days') === 0;
};

export const isYesterday = (date: Date): boolean => {
  return moment().diff(date, 'days') === 1;
};

export const isGreaterThanToday = (date: Date): boolean => {
  return moment().isBefore(date);
};
